export { ProductInfoGroup, ProductInfoItem } from './product-info-group'
export type { ProductInfoGroupProps, ProductInfoItemProps } from './product-info-group'
